import React, { useState } from "react";

import BottomSheet from "../BottomSheet";
import Input from "../Input";
import Loader from "src/components/common/Loader";

interface AddLocationBottomSheetProps {
  showBottomSheet: boolean;
  setShowBottomSheet: (show: boolean) => void;
}

const AddLocationBottomSheet: React.FC<AddLocationBottomSheetProps> =
  React.memo(
    ({ showBottomSheet, setShowBottomSheet }: AddLocationBottomSheetProps) => {
      const [pincode, setPincode] = useState("");
      const [isPincodeLoading, setIsPincodeLoading] = useState(false);
      return (
        <BottomSheet
          show={showBottomSheet}
          handleClose={() => setShowBottomSheet(false)}
          showCloseButton
        >
          <div className="fixed max-w-lg mx-auto w-full bottom-0 left-0 right-0 z-20 transition-transform duration-300 transform translate-y-0">
            <div className="bg-white rounded-t-lg p-4 min-h-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
              <h1 className="text-lg font-semibold">Enter Location</h1>
              <div className="mt-4">
                <Input
                  name="location"
                  type="text"
                  placeholder="Enter Pincode"
                  fullWidth
                  value={pincode}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replace(/\D/g, ""); // Remove non-numeric
                    if (onlyDigits.length <= 6) {
                      setPincode(onlyDigits);
                    }
                  }}
                  endAdornment={
                    isPincodeLoading ? (
                      <Loader size="sm" />
                    ) : (
                      <p
                        className={`text-sm ${
                          pincode.length === 6 ? "text-green-500" : ""
                        }`}
                      >
                        Apply
                      </p>
                    )
                  }
                />
              </div>
              {/* Location content goes here */}
              <div className="mt-4">
                <div className="flex items-center gap-2">
                  <span
                    className="w-5 h-5 flex items-center justify-center"
                    onClick={() => {
                      setIsPincodeLoading(true);
                    }}
                  >
                    {/* Replace with your own icon if not using Lucide */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-700"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 12v.01M12 2v2m0 16v2m10-10h-2M4 12H2m16.95 4.95l-1.414-1.414M7.05 7.05L5.636 5.636m12.728 0L16.95 7.05M7.05 16.95l-1.414 1.414"
                      />
                    </svg>
                  </span>
                  <span
                    className="text-sm font-medium"
                    onClick={() => {
                      setIsPincodeLoading(true);
                    }}
                  >
                    Use Current Location
                  </span>
                </div>
              </div>
            </div>
          </div>
        </BottomSheet>
      );
    }
  );

export default AddLocationBottomSheet;
